module.exports = __webpack_public_path__ + "static/img/dev4.6ffcb4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/dev4.jpg
// module id = FSt5
// module chunks = 3